import { useState } from 'react';
import { UseFieldArrayAppend, useFormContext } from 'react-hook-form';
import { Content } from 'src/contexts/ContentContext/Content';
import { PosTextField } from 'src/core/POS/PosTextField';
import { vars } from 'src/core/themes';
import { Button, Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';
import { newBigIntId } from 'src/utils/idUtils';
import { posChangedField, posField } from 'src/utils/posFieldUtils';
import { PurchaseTicketsInput } from 'src/utils/purchaseUtils';
import { DeliveryType } from 'src/WebApiController';

import { AutoBroadcastSection } from './Footer/AutoBroadcastSection';
import { InHandDateSection } from './Footer/InHandDateSection';
import * as styles from './TicketGroupInputTable.css';

export const TicketGroupInputTableFooter = ({
  append,
  poId,
  deliveryOverrideDefaultIsLoading,
}: {
  append: UseFieldArrayAppend<PurchaseTicketsInput, 'ticketGroups'>;
  poId?: number;
  deliveryOverrideDefaultIsLoading?: boolean;
}) => {
  const { getValues } = useFormContext<PurchaseTicketsInput>();

  const [numOfAddRows, setNumOfAddRows] = useState(3);
  const newPurchaseOrder = poId && poId < 0;

  return (
    <Stack
      direction="row"
      className={styles.tableFooter}
      justifyContent={'spaceBetween'}
    >
      <Stack gap={'l'}>
        <Stack>
          <div data-testid="add-row-count">
            <PosTextField
              rootProps={{
                style: {
                  width: 60,
                  padding: `0 8px`,
                  fontSize: vars.typography.fontSize.base,
                },
              }}
              type="number"
              value={numOfAddRows}
              onChange={(e) => setNumOfAddRows(Number(e.target.value))}
            />
          </div>
          <Button
            variant="textPlain"
            data-testid="add-row-button"
            onClick={() => {
              const { ticketGroups } = getValues();
              const newRows = Array.from(
                { length: numOfAddRows },
                (_, index) => {
                  const inHandDate = ticketGroups[0]?.inHandDate;

                  const id = newBigIntId() + index;
                  return {
                    ...ticketGroups[0],
                    inHandDate,
                    ticketGroupId: id,
                    section: posChangedField(''),
                    sectionId: posChangedField(null),
                    row: posChangedField(null),
                    listingNotes: posChangedField(null),
                    numberOfTickets: posChangedField(null),
                    tickets: posChangedField(null),
                    unitCost: posChangedField(null),
                    totalCost: posChangedField(null),
                    faceValueCost: posField(null),
                    expectedValue: posChangedField(null),
                    deliveryType: posChangedField(DeliveryType.InApp),
                  };
                }
              );

              append(newRows);
            }}
            style={{ fontSize: vars.typography.fontSize.base }}
          >
            <Content id={ContentId.AddRow} />
          </Button>
        </Stack>
        <InHandDateSection
          deliveryOverrideDefaultIsLoading={deliveryOverrideDefaultIsLoading}
        />
      </Stack>
      {newPurchaseOrder && <AutoBroadcastSection />}
    </Stack>
  );
};
